import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import {
  type Collection,
  type CreateCollectionPayload,
} from '../types';
import { collectionApi } from '../api';
import { collectionKeys } from './collection.keys';

// Mutação de criação
export function useCreateCollection(
  options?: UseMutationOptions<Collection, Error, CreateCollectionPayload>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['collections', 'create'],
    mutationFn: collectionApi.create,
    ...mutationOptions,
    onSuccess: (collection, variables, onMutateResult, context) => {
      toast({
        title: 'Coleção criada com sucesso',
        variant: 'success',
      });
      queryClient.invalidateQueries({ queryKey: collectionKeys.all });
      providedOnSuccess?.(collection, variables, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao criar coleção',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  return {
    createCollection: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
